// Import our styles
import './scss/index.scss';

import RfaViewer from './js/index';

window.RfaViewer = document.RfaViewer = Element.prototype.RfaViewer
  = window.RfaViewer || document.RfaViewer || Element.prototype.RfaViewer || new RfaViewer();
